// extracted by mini-css-extract-plugin
export default {"container":"packageInfo-module__container__fNQR4","title":"packageInfo-module__title__-ehE1"};